<template>
    <div class="my-login-dialog" v-if="visible">
        <div class="overlay"></div>
        <div class="wrapper-login" ref="login">
            <div class="title">
                <h4>登录</h4>
                <!-- <i @click.stop="close"></i> -->
            </div>
            <div class="wrapper-form">
                <div class="form-item">
                    <input
                        class="input-item"
                        placeholder="请输入手机号"
                        v-model="phoneNum"
                        maxlength="11"
                        ref="phoneNum"
                        @blur.prevent="inputLoseFocus"
                        @focus="inputFocus('phoneNum')"
                    />
                </div>
                <div class="form-item">
                    <input
                        class="input-item code-input"
                        placeholder="请输入短信验证码"
                        v-model="code"
                        ref="code"
                        @blur.prevent="inputLoseFocus"
                        @focus="inputFocus('code')"
                        maxlength="6"
                    />
                    <div
                        class="btn-code"
                        @click="validatePhoneNum"
                        :class="{ clickable: isCounting }"
                    >
                        {{ isCounting ? `重新获取(${second})` : sendText }}
                    </div>
                </div>
                <p class="agree-item" ref="aggr">
                    <checkbox
                        v-model="agreeReg"
                        shape="square"
                        checked-color="#FF6B20"
                        icon-size="12px"
                    ></checkbox
                    >本人同意注册/登录东方财富账户
                </p>
                <p class="agree-item">
                    <checkbox
                        v-model="agreeAgr"
                        shape="square"
                        checked-color="#FF6B20"
                        icon-size="12px"
                    ></checkbox>
                    本人已阅读并同意
                    <a href="https://emuserh5.eastmoney.com/UserAgreement/fwxy">《用户服务协议》</a
                    >与
                    <a href="https://emuserh5.eastmoney.com/UserAgreement/yszc">《隐私协议》</a>
                </p>
                <div id="divCaptcha"></div>
                <div class="start-btn" @click.stop="getStart">{{ submitText }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Checkbox } from 'vant';
import { setAuthCookies, removeAuthCookies } from '@/libs/auth-cookie';
import { mapState } from 'vuex';
import browser from '@/libs/browser';
import { getVerificationContext, getConsolidate, resendMsg, handleLogin } from '@/apis/verify-code';
import {
    DB_KAISHI_DATI,
    DB_LOGIN_INPUT_MOBILE,
    DB_LOGIN_GET_VERIFY,
    DB_LOGIN_INPUT_VERIFY
} from '@/libs/constant';

export default {
    name: '',
    components: {
        Checkbox
    },
    data() {
        return {
            visible: false,
            submitText: '登录',
            phoneNum: '',
            sendText: '获取验证码',
            code: '',
            apiContext: '',
            isCounting: '',
            second: '',
            agreeReg: '',
            agreeAgr: '',
            clearApiContextInterval: '',
            msgInterval: ''
        };
    },
    computed: {
        isPhoneNumLegal() {
            return this.checkTelNumber(this.phoneNum);
        },
        isCodeLegal() {
            return this.checkMessageVCode(this.code);
        },
        isApp() {
            return browser.isApp();
        },
        ...mapState(['needLogin'])
    },
    mounted() {
        this.adjustCapchaInputPos();
    },
    methods: {
        getStart() {
            this.$track(DB_KAISHI_DATI);
            this.validateForm();
        },
        adjustCapchaInputPos() {
            let flag;
            let inputTimer = null;
            // 软键盘弹起事件
            document.body.addEventListener('focusin', e => {
                if (e && e.target && e.target.className === 'em_input') {
                    flag = true;
                    if (inputTimer) {
                        clearTimeout(inputTimer);
                    }
                }
            });
            // 软键盘关闭事件
            document.body.addEventListener('focusout', e => {
                if (e && e.target && e.target.className === 'em_input') {
                    flag = false;
                    if (!flag) {
                        inputTimer = setTimeout(() => {
                            // 重点  =======当键盘收起的时候让页面回到原始位置(这里的top可以根据你们个人的需求改变，并不一定要回到页面顶部)
                            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        }, 200);
                    }
                }
            });
        },
        checkTelNumber(value) {
            return /^[1][3456789][0-9]{9}$/.test(value);
        },
        checkMessageVCode(value) {
            return /^[0-9]{6}$/.test(value);
        },
        // 校验手机号和勾选项
        validateRequiredItem() {
            if (!this.phoneNum) {
                this.$toast('请输入手机号');
                return false;
            }
            if (!this.isPhoneNumLegal) {
                this.$toast('请输入正确手机号');
                return false;
            }
            if (!this.agreeReg) {
                this.$toast('请先同意注册/登录东方财富账户');
                return false;
            }
            if (!this.agreeAgr) {
                this.$toast('请先同意《用户服务协议》与《隐私政策》');
                return false;
            }
            return true;
        },
        // 校验手机号输入
        validatePhoneNum() {
            if (!this.validateRequiredItem()) {
                return;
            }
            if (this.isCounting) {
                return;
            }
            this.$track(DB_LOGIN_GET_VERIFY);
            if (this.apiContext) {
                this.resendMessage();
                return;
            }
            this.getCapcha();
        },
        // 登录校验
        async validateForm() {
            if (!this.validateRequiredItem()) {
                return;
            }
            if (!this.code || !this.apiContext) {
                this.$toast('请先获取短信验证码');
                return;
            }
            if (!this.isCodeLegal) {
                this.$toast('输入正确短信验证码');
                return;
            }
            // 验证短信
            const params = {
                phone: this.phoneNum,
                activeCode: this.code,
                apiContext: this.apiContext || ''
            };
            const res = await handleLogin(params);
            if (res.data.success && res.data.data) {
                this.setToken(res.data.data);
                this.$toast('登录成功');
                this.$emit('on-success');
                this.close();
            } else {
                this.$toast(res.data.message || '登录失败，请稍候重试');
                this.setToken('');
            }
        },
        setToken(data) {
            if (!data || !data.CToken) {
                removeAuthCookies();
                return;
            }
            setAuthCookies({
                ct: data.CToken,
                ut: data.UToken,
                sessionId: data.SessionID
            });
        },
        // 获取验证码captchaContextId,验证码出书啊
        async getCapcha() {
            const capchaConfig = {
                AppId: '201901231134',
                Scope: 'f27efeb8'
            };
            const { data } = await getVerificationContext(capchaConfig);
            if (data.success && data.data) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                // const phoneNumItem = this.$refs.phoneNum.blur();
                const capt = window
                    .EMCaptcha({
                        containerId: 'divCaptcha',
                        appid: capchaConfig.AppId,
                        status: data.code,
                        captchaContextId: data.data,
                        product: 'bind'
                    })
                    .onSuccess(() => {
                        this.inputLoseFocus();
                        const params = {
                            phone: this.phoneNum,
                            // captContext: data.data,
                            captContext: capt.getValidate().contextId,
                            captValidate: capt.getValidate().validate
                        };
                        this.getMessage(params);
                    })
                    .onError(err => {
                        this.inputLoseFocus();
                        console.log(err);
                    });
                console.log(capt);
                capt.verify(this.phoneNum, '');
            }
        },
        clearMsgInterVal(interval) {
            if (interval) {
                window.clearInterval(interval);
            }
            // interval = null;
        },
        // 短信倒计时
        countdown() {
            this.isCounting = true;
            this.second = 60;
            this.clearMsgInterVal(this.msgInterval);
            this.msgInterval = setInterval(() => {
                if (this.second <= 1) {
                    this.clearMsgInterVal(this.msgInterval);
                    this.sendText = '重新获取';
                    this.isCounting = false;
                }
                this.second -= 1;
            }, 1000);
        },
        clearApiContext() {
            this.clearMsgInterVal(this.clearApiContextInterval);
            const startTime = new Date().getTime();
            this.clearApiContextInterval = setInterval(() => {
                const nowTime = new Date().getTime();
                const timeBetween = Math.floor((nowTime - startTime) / 1000);
                if (timeBetween >= 300) {
                    this.isCounting = false;
                    this.sendText = '获取验证码';
                    this.apiContext = '';
                    this.clearMsgInterVal(this.clearApiContextInterval);
                }
            }, 1000);
        },
        // 解决移动端弹出键盘时遮挡输入框
        inputScrollToView() {
            const pannel = this.$refs.login;
            setTimeout(() => {
                pannel.scrollIntoView();
            }, 200);
        },
        // 获取短信验证码
        async getMessage(params) {
            const { data } = await getConsolidate(params);
            if (data.success && data.data) {
                this.countdown();
                this.apiContext = data.data;
                this.$toast('验证码已发送');
                this.clearApiContext();
            } else {
                this.$toast('获取短信验证码失败');
                this.apiContext = '';
                this.getCapcha();
            }
        },
        // 重新获取短信验证码
        async resendMessage() {
            const params = {
                phone: this.phoneNum,
                apiContext: this.apiContext || ''
            };
            const { data } = await resendMsg(params);
            if (data.success && data.data) {
                this.countdown();
                this.apiContext = data.data;
                this.$toast('验证码已发送');
                this.clearApiContext();
            } else {
                this.$toast('获取短信验证码失败');
                this.apiContext = '';
                this.getCapcha();
            }
        },
        inputFocus(formItem) {
            if (browser.isIOS()) {
                this.$nextTick(() => {
                    const wrapper = this.$refs.login;
                    // wrapper.style.position = 'absolute';
                    if (navigator.userAgent.indexOf('Safari') > -1 || browser.isWeixin()) {
                        wrapper.style.minHeight = '500px';
                    }
                });
                this.inputScrollToView();
            } else {
                this.inputScrollToView();
            }
            if (formItem === 'phoneNum') {
                this.$track(DB_LOGIN_INPUT_MOBILE);
            } else {
                this.$track(DB_LOGIN_INPUT_VERIFY);
            }
        },
        // input 输入失焦
        inputLoseFocus() {
            window.scroll(0, 0);
            if (browser.isIOS()) {
                this.$nextTick(() => {
                    const wrapper = this.$refs.login;
                    if (navigator.userAgent.indexOf('Safari') > -1 || browser.isWeixin()) {
                        wrapper.style.minHeight = '';
                    }
                    wrapper.style.position = 'fixed';
                    wrapper.style.bottom = '0';
                });
            }
        },
        initForm() {
            this.phoneNum = '';
            this.code = '';
            this.apiContext = '';
            this.sendText = '获取验证码';
            this.clearMsgInterVal(this.msgInterval);
            this.clearMsgInterVal(this.clearApiContextInterval);
            this.msgInterval = null;
            this.clearApiContextInterval = null;
            this.agreeReg = false;
            this.agreeAgr = false;
            this.second = 60;
            this.isCounting = false;
        },
        close() {
            this.visible = false;
            this.$emit('close');
            this.initForm();
        },
        show() {
            this.visible = true;
        }
    }
};
</script>

<style scoped lang="scss">
.em_widget.em_show {
    font-size: 28px;
    line-height: 1;
}
.my-login-dialog {
    width: 100%;
    height: 100vh;
    position: relative;
    -webkit-overflow-scrolling: touch;
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        padding: 0 48px;
        background-color: rgba(0, 0, 0, 0.7);
    }
    .wrapper-login {
        background: #fff;
        width: 100%;
        border-radius: 20px 20px 0 0;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 900;
        width: 100%;
        .title {
            position: relative;
            h4 {
                width: 100%;
                height: 120px;
                line-height: 120px;
                font-size: 36px;
                font-weight: bold;
                text-align: center;
            }
            i {
                position: absolute;
                width: 48px;
                height: 48px;
                background: url('~@/assets/images/close.png');
                background-size: cover;
                right: 40px;
                top: 36px;
            }
        }
        .wrapper-form {
            padding: 20px 48px 48px 48px;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;
            .form-item {
                margin-bottom: 30px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .input-item {
                    width: 100%;
                    height: 100px;
                    border-radius: 8px;
                    background-color: #f8f8fa;
                    font-size: 32px;
                    color: #333;
                    padding-left: 30px;
                    &::placeholder {
                        font-size: 32px;
                        color: #999999;
                        letter-spacing: 0;
                    }
                    &.code-input {
                        width: 378px;
                    }
                }
                .btn-code {
                    display: inline-block;
                    font-size: 30px;
                    font-weight: bold;
                    color: #000;
                    background: #ddd;
                    width: 240px;
                    height: 92px;
                    line-height: 92px;
                    text-align: center;
                    background: #fecf21;
                    border: 2px solid #000000;
                    border-radius: 16px;
                }
                .clickable {
                    color: #999;
                    border: 2px solid #f0f0f0;
                    background: #fafafc;
                }
            }
            .agree-item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                color: #999;
                margin-top: 6px;
                font-size: 22px;
                line-height: 32px;
                .van-checkbox {
                    cursor: pointer;
                    margin-right: 6px;
                    .van-icon {
                        line-height: 1;
                    }
                }

                a {
                    color: #007aff;
                    cursor: pointer;
                }
            }
            .start-btn {
                width: 100%;
                height: 100px;
                text-align: center;
                line-height: 100px;
                border-radius: 16px;
                border: 2px solid #000;
                font-size: 32px;
                color: #fff;
                background: #ff6b20;
                margin-top: 36px;
            }
        }
    }
}
</style>
